import { PlantModule } from './modules/plant/plant.module';
import { ParentRejectionModule } from './modules/parent-rejection/parent-rejection.module';
import { SequenceModule } from './modules/sequence/sequence.module';
import { NomineeModule } from './modules/nominee/nominee.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './core/layout/base/base.component';
import { LoginComponent } from './modules/auth/pages/login/login.component';
import { MainContentComponent } from './modules/dashboard/main-content/main-content.component';
import { AuthGuardService } from './modules/auth/auth-guard.service';
import { ThankYouComponent } from './shared/components/thank-you/thank-you.component';
import { AdminPortalComponent } from './shared/components/admin-portal/admin-portal.component';
import { RoleGuard } from './modules/auth/role-guard.service';
import { BuyingGradingAccuracyComponent } from './modules/harcoded-reports/buying-grading-accuracy/buying-grading-accuracy.component';
import { GrowerTaxCertificateComponent } from './modules/harcoded-reports/grower-tax-certificate/grower-tax-certificate.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  // { path: 'buyingGrading', component: BuyingGradingAccuracyComponent },
  {
    path: '',
    component: BaseComponent,

    children: [
      {
        path: '',
        component: MainContentComponent,
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'assign-feature-role',
        loadChildren: () =>
          import('./modules/assign-role/assign-role.module').then(
            (m) => m.AssignRoleModule
          ),
      },
      {
        path: 'features',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/feature-mapping/feature-mapping.module').then(
            (m) => m.FeatureMappingModule
          ),
      },
      {
        path: 'grade',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/grade/grade.module').then((m) => m.GradeModule),
      },
      {
        path: 'tobacco',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/tobacco/tobacco.module').then(
            (m) => m.TobaccoModule
          ),
      },
      {
        path: 'bank-details',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/bank-details/bank-details.module').then(
            (m) => m.BankDetailsModule
          ),
      },
      {
        path: 'location',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/location/location.module').then(
            (m) => m.LocationModule
          ),
      },
      {
        path: 'payment-type',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/payment-type/payment-type.module').then(
            (m) => m.PaymentTypeModule
          ),
      },
      {
        path: 'bank-branch',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/bank-branch/bank-branch.module').then(
            (m) => m.BankBranchModule
          ),
      },
      {
        path: 'farmer-status',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/farmer-status/farmer-status.module').then(
            (m) => m.FarmerStatusModule
          ),
      },
      {
        path: 'area',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/area/area.module').then((m) => m.AreaModule),
      },
      {
        path: 'sector',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/sector/sector.module').then((m) => m.SectorModule),
      },
      {
        path: 'village',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/village/village.module').then(
            (m) => m.VillageModule
          ),
      },
      {
        path: 'mahal',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/mahal/mahal.module').then((m) => m.MahalModule),
      },
      {
        path: 'generic-deduction',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/generic-dedeuction/generic-dedeuction.module').then(
            (m) => m.GenericDedeuctionModule
          ),
      },
      {
        path: 'generic-incentive',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/generic-incentive/generic-incentive.module').then(
            (m) => m.GenericIncentiveModule
          ),
      },
      {
        path: 'generic-flag',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/generic-flag/generic-flag.module').then(
            (m) => m.GenericFlagModule
          ),
      },
      {
        path: 'department',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/department/department.module').then(
            (m) => m.DepartmentModule
          ),
      },
      {
        path: 'buyer',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/buyer-ctrl/buyer-ctrl.module').then(
            (m) => m.BuyerCtrlModule
          ),
      },
      {
        path: 'buying-center',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/buying-center/buying-center.module').then(
            (m) => m.BuyingCenterModule
          ),
      },
      {
        path: 'quota',
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import('./modules/quota/quota.module').then((m) => m.QuotaModule),
      },
      {
        path: 'grade-year',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/grade-year/grade-year.module').then(
            (m) => m.GradeYearModule
          ),
      },
      {
        path: 'deduction-location',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/deduction-location/deduction-location.module').then(
            (m) => m.DeductionLocationModule
          ),
      },
      {
        path: 'incentive-location',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/incentive-location/incentive-location.module').then(
            (m) => m.IncentiveLocationModule
          ),
      },
      {
        path: 'flags-location',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/flags-location/flags-location.module').then(
            (m) => m.FlagsLocationModule
          ),
      },
      {
        path: 'farmer-data',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/farmer-data/farmer-data.module').then(
            (m) => m.FarmerDataModule
          ),
      },
      {
        path: 'cpa-substance-deduction',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/cpa-substance-deduction/cpa-substance-deduction.module'
          ).then((m) => m.CpaSubstanceDeductionModule),
      },
      {
        path: 'blend-maintenance-ratio',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/bom-creation/bom-creation.module').then(
            (m) => m.BomCreationModule
          ),
      },
      {
        path: 'app-config',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/app-configuration/app-configuration.module').then(
            (m) => m.AppConfigurationModule
          ),
      },
      {
        path: 'qa-daily-setup',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/qa-daily-setup/qa-daily-setup.module').then(
            (m) => m.QaDailySetupModule
          ),
      },
      {
        path: 'qa-cpa-setup',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/qa-cpa-setup/qa-cpa-setup.module').then(
            (m) => m.QaCpaSetupModule
          ),
      },
      {
        path: 'new-composite-testing',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/new-composite-testing/new-composite-testing.module').then(
            (m) => m.NewCompositeTestingModule
          ),
      },
      {
        path: 'new-individual-testing',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/new-individual-testing/new-individual-testing.module').then(
            (m) => m.NewIndividualTestingModule
          ),
      },
      {
        path: 'purchase-open',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/purchase-open/purchase-open.module').then(
            (m) => m.PurchaseOpenModule
          ),
      },
      // {
      //   path: 'buying',
      //   // canActivate: [AuthGuardService, RoleGuard],
      //   loadChildren: () =>
      //     import('./modules/buying/buying.module').then((m) => m.BuyingModule),
      // },
      {
        path: 'warehouse/bin',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/bin/bin.module').then((m) => m.BinModule),
      },
      {
        path: 'warehouse/fleet',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/fleet/fleet.module').then((m) => m.FleetModule),
      },
      {
        path: 'warehouse/dispatch',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/dispatch/dispatch.module').then(
            (m) => m.DispatchModule
          ),
      },
      {
        path: 'warehouse/binMovement',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/bin-movement/bin-movement.module').then(
            (m) => m.BinMovementModule
          ),
      },
      {
        path: 'warehouse/deplete',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/deplete-reason/deplete-reason.module').then(
            (m) => m.DepleteReasonModule
          ),
      },
      {
        path: 'warehouse/transport',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/transport/transport.module').then(
            (m) => m.TransportModule
          ),
      },
      {
        path: 'warehouse/storagestrategy',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/storage-strategy/storage-strategy.module').then(
            (m) => m.StorageStrategyModule
          ),
      },
      {
        path: 'warehouse/storageType',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/storage-type/storage-type.module').then(
            (m) => m.StorageTypeModule
          ),
      },
      {
        path: 'warehouse/transport',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/transport/transport.module').then(
            (m) => m.TransportModule
          ),
      },
      {
        path: 'warehouse',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/warehouse/warehouse.module').then(
            (m) => m.WarehouseModule
          ),
      },
      {
        path: 'warehouse/godown',
        loadChildren: () =>
          import('./modules/godown/godown.module').then((m) => m.GodownModule),
      },
      {
        path: 'sweeping-bale',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/sweep-bale/sweep-bale.module').then(
            (m) => m.SweepBaleModule
          ),
      },
      {
        path: 'admin',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'ntrm',
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import('./modules/ntrm/ntrm.module').then((m) => m.NtrmModule),
      },
      {
        path: 'cpa',
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import('./modules/cpa/cpa.module').then((m) => m.CPAModule),
      },
      {
        path: 'nominee',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/nominee/nominee.module').then(
            (m) => m.NomineeModule
          ),
      },
      {
        path: 'uploader',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/data-uploader/data-uploader.module').then(
            (m) => m.DataUploaderModule
          ),
      },
      {
        path: 'sequence',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/sequence/sequence.module').then(
            (m) => m.SequenceModule
          ),
      },
      {
        path: 'payment-terms',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/payment-terms/payment-terms.module').then(
            (m) => m.PaymentTermsModule
          ),
      },
      {
        path: 'price-uploader-controls',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/grades-controls/grades-controls.module').then(
            (m) => m.GradesControlsModule
          ),
      },
      {
        path: 'sequence-type',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/sequence-type/sequence-type.module').then(
            (m) => m.SequenceTypeModule
          ),
      },
      {
        path: 'cash-voucher',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/cash-voucher/cash-voucher.module').then(
            (m) => m.CashVoucherModule
          ),
      },
      {
        path: 'unpaid-voucher',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/unpaid-voucher/unpaid-voucher.module').then(
            (m) => m.UnpaidVoucherModule
          ),
      },
      {
        path: 'coc',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/coc/coc.module').then((m) => m.CocModule),
      },
      {
        path: 'voucher-correction',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/voucher-correction/voucher-correction.module').then(
            (m) => m.VoucherCorrectionModule
          ),
      },
      {
        path: 'purchase-data-validation',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/purchase-data-validation/purchase-data-validation.module'
          ).then((m) => m.PurchaseDataValidationModule),
      },
      {
        path: 'cpa-cash-recovery',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/cpa-cash-recovery-entry/cpa-cash-recovery-entry.module'
          ).then((m) => m.CpaCashRecoveryEntryModule),
      },
      {
        path: 'composite-barcode-rollback-uploader',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/composite-barcode-rollback-uploader/composite-barcode-rollback-uploader.module'
          ).then((m) => m.CompositeBarcodeRollbackUploaderModule),
      },
      {
        path: 'sap',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/sap-invoice/sap-invoice.module').then(
            (m) => m.SapInvoiceModule
          ),
      },
      {
        path: 'check-stock-register',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/check-stock-register/check-stock-register.module'
          ).then((m) => m.CheckStockRegisterModule),
      },
      {
        path: 'inventory-upload',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/inventory-upload/inventory-upload.module').then(
            (m) => m.InventoryUploadModule
          ),
      },
      {
        path: 'coc-approval',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/coc-approval-matrix/coc-approval-matrix.module'
          ).then((m) => m.CocApprovalMatrixModule),
      },
      {
        path: 'workflow-configuration',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/work-flow-configuration/work-flow-configuration.module'
          ).then((m) => m.WorkFlowConfigurationModule),
      },
      {
        path: 'workflow-task',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/work-flow-task/work-flow-task.module').then(
            (m) => m.WorkFlowTaskModule
          ),
      },
      {
        path: 'approved-workflows',
        pathMatch: 'full',
        canActivate: [AuthGuardService, RoleGuard],
        redirectTo: 'workflow-task/approved',
      },
      {
        path: 'qa-sampling',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/qa-sampling/qa-sampling.module').then(
            (m) => m.QaSamplingModule
          ),
      },
      {
        path: 'composite',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/composite-testing/composite-testing.module').then(
            (m) => m.CompositeTestingModule
          ),
      },
      {
        path: 'rejection',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/rejection/rejection.module').then(
            (m) => m.RejectionModule
          ),
      },
      {
        path: 'farmer-category',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/farmer-category/farmer-category.module').then(
            (m) => m.FarmerCategoryModule
          ),
      },
      {
        path: 'farmer-quota',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/farmer-quota/farmer-quota.module').then(
            (m) => m.FarmerQuotaModule
          ),
      },
      {
        path: 'material-parent',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/material-parent/material-parent.module').then(
            (m) => m.MaterialParentModule
          ),
      },
      {
        path: 'setup-material',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/material-setup/material-setup.module').then(
            (m) => m.MaterialSetupModule
          ),
      },
      {
        path: 'coi-description',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/coi-description/coi-description.module').then(
            (m) => m.CoiDescriptionModule
          ),
      },
      {
        path: 'transport-charges',
        canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/transport-charge/transport-charge.module').then(
            (m) => m.TransportChargeModule
          ),
      },
      {
        path: 'buying-dashboard',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/buying-dashboard/buying-dashboard.module').then(
            (m) => m.BuyingDashboardModule
          ),
      },
      {
        path: 'quota-extension-types',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/quota-extension-types/quota-extension-types.module'
          ).then((m) => m.QuotaExtensionTypesModule),
      },
      {
        path: 'parent-grade',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/parent-grade/parent-grade.module').then(
            (m) => m.ParentGradeModule
          ),
      },
      {
        path: 'parent-rejection',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/parent-rejection/parent-rejection.module').then(
            (m) => m.ParentRejectionModule
          ),
      },
      {
        path: 'plant',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/plant/plant.module').then((m) => m.PlantModule),
      },
      {
        path: 'report-dashboard',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import(
            './modules/reporting-dashboarding/reporting-dashboarding.module'
          ).then((m) => m.ReportingDashboardingModule),
      },
      {
        path: 'hardcoded-reports',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/harcoded-reports/harcoded-reports.module').then(
            (m) => m.HarcodedReportsModule
          ),
      },
      {
        path: 'workflow-logs',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/workflow-logs/workflow-logs.module').then(
            (m) => m.WorkflowLogsModule
          ),
      },
      {
        path: 'unscanned-bales',
          // canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/unscanned-bales/unscanned-bales.module').then(
            (m) => m.UnscannedBalesModule
          ),
      },
      {
        path: 'user-access-logs',
          canActivate: [AuthGuardService, RoleGuard],
        loadChildren: () =>
          import('./modules/user-access-logs/user-access-logs.module').then(
            (m) => m.UserAccessLogsModule
          ),
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    // loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'thank-you',
    component: ThankYouComponent,
  },
  // {
  //   path: 'buyingGrading',
  //   component: BuyingGradingAccuracyComponent,
  // },
  // {
  //   path: 'grower-tax-certificate',
  //   component: GrowerTaxCertificateComponent,
  // },
  {
    path: 'admin-portal',
    component: AdminPortalComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
